import { loader } from 'graphql.macro'

export default function recurringTicketQuery ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./recurringTicket.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId: variables.haulerId,
    ticketId: variables.ticketId
  })
}
